import { hyphenateHTMLSync } from 'hyphen/de';

const hyphen = () => {
  Array.from(
    document.querySelectorAll('h1,h2,h3,h4,.c-table__item__title'),
  ).forEach(el => {
    // eslint-disable-next-line no-param-reassign
    el.innerHTML = hyphenateHTMLSync(el.innerHTML, {
      debug: false,
      minWordLength: 5,
    });
  });
};

export default hyphen;



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/hyphen.js